import type { Space } from '@mail/cross-sizes-utils';

export interface ApiQuotaResponse {
    quota: number;
    used: {
        total: number;
        cloud: number;
        mail: number;
    };
    single_quota_enabled: boolean;
    disable_mail_bin: boolean; // Корзина Почты не учитывается в квоте
    isSilent: boolean;
}

export interface State {
    isLoading: boolean;
    isLoaded: boolean;
    isSingleQuotaEnabled: boolean;
    isMailBinDisabled: boolean;
    quota: Space | null;
    used: {
        total: Space | null;
        cloud: Space | null;
        mail: Space | null;
    };
}

export interface IUserQuotaState {
    usedPercent: number;
    used: Space | null;
    remaining: Space;
    userTotalSpace: Space | null;
    isOverQuota: boolean;
}

export interface ITotalQuota {
    totalSize?: number;
    usedSize?: number;
    freeSize?: number;
}

export const enum OverquotaType {
    All = 'all',
    PureMail = 'pure_mail',
    Mail = 'mail',
    Cloud = 'cloud',
    Union = 'union',
}
